export const LATEST_BOOKING_DATE_FORMAT = "DD/MM/YYYY";
